module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-limited-time-offers-992e2b0015db46f9475a32ef0e495851.png";